
// Init Wishlist
const initWishlist = () => {
    let wishlist = JSON.parse(localStorage.getItem('eg_wishlist')) || []

    document.querySelectorAll('.btn-wishlist:not(.init)').forEach((btn) => {
        const isWishlisted = wishlist.some((product) => product.id === btn.dataset.productId)

        if (isWishlisted) {
            btn.title = btn.dataset.textRemoveFromWishlist
            btn.classList.add('active')
        } else {
            btn.title = btn.dataset.textAddToWishlist
            btn.classList.remove('active')
        }

        new bootstrap.Tooltip(btn) // eslint-disable-line no-new

        btn.addEventListener('click', (e) => {
            e.preventDefault()
            btn.classList.add('init')
            bootstrap.Tooltip.getInstance(btn).hide()
            bootstrap.Tooltip.getInstance(btn).disable()
            const isWishlisted = wishlist.some((product) => product.id === btn.dataset.productId)

            if (isWishlisted) {
                wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
                btn.title = btn.dataset.textAddToWishlist
                btn.classList.remove('active')
            } else {
                wishlist.push({
                    id: btn.dataset.productId,
                    title: btn.dataset.productTitle,
                    url: btn.dataset.productUrl,
                    compare_at_price: btn.dataset.productCompareAtPrice,
                    price: btn.dataset.productPrice,
                    price_varies: btn.dataset.productPriceVaries,
                    img_src: btn.dataset.productImgSrc,
                    img_alt: btn.dataset.productImgAlt,
                    wishlisted_at: Date.now()
                })
                btn.title = btn.dataset.textRemoveFromWishlist
                btn.classList.add('active')
            }
            localStorage.setItem('eg_wishlist', JSON.stringify(wishlist))
            new bootstrap.Tooltip(btn) // eslint-disable-line no-new
            initWishlist()
            loadOffcanvasWishlist()
        })
    })

    const wishlistBadge = document.querySelector('.wishlist-items-count')

    if (wishlist.length === 0) {
        wishlistBadge.textContent = wishlist.length
        wishlistBadge.classList.remove(wishlistBadge.dataset.bgHasItems)
        wishlistBadge.classList.add(wishlistBadge.dataset.bgEmpty)
    } else {
        wishlistBadge.textContent = wishlist.length
        wishlistBadge.classList.remove(wishlistBadge.dataset.bgEmpty)
        wishlistBadge.classList.add(wishlistBadge.dataset.bgHasItems)
    }
}
initWishlist()

// Load products in offcanvas wishlist
const loadOffcanvasWishlist = () => {
    const offcanvas = document.querySelector('#offcanvas-wishlist')
    let wishlist = JSON.parse(localStorage.getItem('eg_wishlist')) || []

    if (wishlist.length > 0) {
        let html = ''
        wishlist.forEach((product, index) => {
            html += `
                <li class="product-list-item">
                    <a href="${product.url}" class="row align-items-center py-1 text-decoration-none">
                        <div class="col-3 px-2">
                            <img 
                                class="product-img img-fluid me-3 ${offcanvas.dataset.imgBorder}"
                                src="${window.resizeImage(product.img_src, `${offcanvas.dataset.imgWidth}x${offcanvas.dataset.imgHeight}`, 'center')}"
                                alt="${product.img_alt}" 
                                width="${offcanvas.dataset.imgWidth}"
                                height="${offcanvas.dataset.imgHeight}"
                                loading="lazy">
                        </div>
                        <div class="col-7 px-2">
                            <h5 class="product-title h6 mb-1">
                                ${product.title}
                            </h5>
                            <p class="product-price text-body mb-1">
                                <s class="product-price-compare text-muted me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                    <span class="visually-hidden">
                                        ${offcanvas.dataset.textOldPrice}
                                    </span>
                                    ${window.formatMoney(product.compare_at_price)}
                                </s>
                                <span class="product-price-final">
                                    <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                        ${offcanvas.dataset.textPriceFrom}
                                    </span>
                                    ${window.formatMoney(product.price)}
                                </span>
                            </p>
                        </div>
                        <div class="col-2 px-2">
                            <button 
                                class="offcanvas-wishlist-btn-remove btn btn-remove d-flex mx-auto text-danger"
                                aria-label="Remove"
                                data-product-id="${product.id}">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16"
                                    class="icon icon-trash"
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    stroke-width="2" 
                                    stroke-linecap="round" 
                                    stroke-linejoin="round">
                                    <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                            </button>
                        </div>
                    </a>
                </li>
            `
            offcanvas.querySelector('#offcanvas-wishlist-empty').style.display = 'none'
            offcanvas.querySelector('#offcanvas-wishlist-product-list').innerHTML = html
            offcanvas.querySelector('#offcanvas-wishlist-product-list').style.display = 'block'
        })
    } else {
        offcanvas.querySelector('#offcanvas-wishlist-empty').style.display = 'block'
        offcanvas.querySelector('#offcanvas-wishlist-product-list').style.display = 'none'
        setTimeout(() => {
            const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist')
            offcanvas.hide()
        }, 500)
    }

    offcanvas.querySelector('#offcanvas-wishlist-counter').innerHTML = wishlist.length

    document.querySelectorAll('.offcanvas-wishlist-btn-remove:not(.init)').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault()
            console.log(e)
            btn.classList.add('init')
            wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
            localStorage.setItem('eg_wishlist', JSON.stringify(wishlist))
            initWishlist()
            loadOffcanvasWishlist()
        })
    })
}

loadOffcanvasWishlist()
